import { TimeseriesChartOverlaysBorder } from '../components/overlays/TimeseriesChartOverlaysBorder.js';
import { ThresholdIndicators } from '../components/thresholds/ThresholdIndicators.js';
import { TimeseriesCanvasLayout } from './TimeseriesCanvasLayout.js';
import { TimeseriesChartGridLayout } from './TimeseriesChartGridLayout.js';

export const TimeseriesChartPlot = () => (
  <>
    <TimeseriesChartGridLayout />
    <ThresholdIndicators indicatorType="range" />
    <TimeseriesCanvasLayout />
    <TimeseriesChartOverlaysBorder />
  </>
);

TimeseriesChartPlot['displayName'] = 'TimeseriesChartPlot';
